'use strict';

export class ReportsIndexCtrl
{
	constructor($scope, jsDataService){
		this.reportTypes = jsDataService.get('reportTypes', '');
	}
}